<dx-popup
  [width]="600"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'COPY-INVITATION-LINK.OVERVIEW.TITLE' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  [(visible)]="showModal"
  (onHiding)="onClose()"
>
  <div *dxTemplate="let data of 'content'">
    @if(internalChannels.length !== 0) {
      <app-table
        class="channel-grid"
        [data]="internalChannels"
        [columns]="internalColumns"
        [showRowLines]="false"
        [showPageSizeSelector]="false"
        [showPagination]="false"
      ></app-table>
    }
    @if(internalChannels.length !== 0) {
      <hr>
    }
    @if(externalChannels.length !== 0) {
      <p class="individual-channels-title">
       {{ 'COPY-INVITATION-LINK.OVERVIEW.MY-INDIVIDUAL-CHANNELS' | translate }}
      </p>
      <app-table
        class="channel-grid"
        [data]="externalChannels"
        [columns]="externalColumns"
        [showRowLines]="false"
        [showPageSizeSelector]="false"
        [showPagination]="false"
      ></app-table>
    }

    <div class="manage-channel-link-container">
      <a
        [routerLink]="['/administration']"
        [queryParams]="{ tab: 'marketing-channels' }"
        target="_blank"
        class="manage-channel-link"
      >
        {{ 'COPY-INVITATION-LINK.OVERVIEW.MANAGE-CHANNELS' | translate }}
        <span class="dx-icon-link-tab"></span>
      </a>
    </div>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
      stylingMode: 'contained',
      type: 'normal',
      text: ('COMMON.OK' | translate),
      onClick: onClose
    }"
  ></dxi-popup-toolbar-item>
</dx-popup>